<template>
  <div>
    <dashboard-header :text='$t("hospitalAffiliation.caption")'/>

    <v-card
        elevation="0"
        class="card-border-10">
      <d-table
          class="pa-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :hide-search="true"
          :edit="null"
          :on-delete="null"
      >
        <!-- Custom status confirmation slot -->
        <template v-slot:item.statusConfirm="{ item }">
          <v-chip
            :color="getStatusColor(item.statusConfirm)"
            :text-color="getStatusTextColor(item.statusConfirm)"
            small>
            {{ getStatusText(item.statusConfirm) }}
          </v-chip>
        </template>

        <!-- Custom actions slot -->
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-btn
              v-if="item.statusConfirm === 0"
              small
              elevation="0"
              class="no-uppercase btn-custom-white mr-2"
              @click="showConfirmDialog(item)">
              <b-img
                  class="mr-2"
                  :src="require('@/assets/images/ic-edit-hospital.svg')"
                  width="16"
                  height="16"
              />
              {{ $t('base.confirm') }}
            </v-btn>
            <v-btn
              v-if="item.statusConfirm === 0"
              small
              elevation="0"
              class="no-uppercase btn-custom-white"
              @click="showRejectDialog(item)">
              <b-img
                  class="mr-2"
                  :src="require('@/assets/images/ic-delete.svg')"
                  width="16"
                  height="16"
              />
              {{ $t('base.reject') }}
            </v-btn>
          </div>
        </template>
      </d-table>
    </v-card>

    <b-modal
        id="modal-loading"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
    >
      <div class="d-block text-center">
        <b-spinner variant="primary" class="m-5" label="Spinning"/>
        <b-card-text>{{ $t("base.loading") }}</b-card-text>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {TYPE_FORMAT_TIME} from "../../config/constant";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import dTable from "../base/DataTable.vue";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      visibleCreate: false,
      // pagination
      currentPage: 1,
      perPage: 10,
      options: {},
      // button edit
      isEdit: false,
      // button delete
      isDelete: false
    };
  },
  mounted() {
    this.getItems({ page: 1, itemsPerPage: 10 });
  },
  computed: {
    fields() {
      return [
        {value: "hospitalCall", text: i18n.t("hospitalAffiliation.hospitalCall"), sortable: false},
        {value: "sosMessage", text: i18n.t("sosCase.sosMessage"), sortable: false},
        {value: "statusConfirm", text: i18n.t("hospitalAffiliation.statusConfirm"), sortable: false, align: "center"},
        {value: "actions", text: "", sortable: false, align: "center"}
      ];
    },
    placeholder() {
      return this.$t('hospital.placeholderSearch');
    }
  },
  methods: {
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      let res = await this.get(API2.CONFIRM, optionParams)

      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        const status = value.confirmed === null ? 0 : value.confirmed;
        return {
          data: {...value, idDetail: value.confirmId},
          hospitalCall: value.hospitalCall.name,
          sosMessage: value.sosCaseInfo.description,
          statusConfirm: status,
          updatedAt: this.formatDate(
              value.updatedAt,
              TYPE_FORMAT_TIME.DD_MM_YYYY
          )
        };
      });
    },
    getStatusColor(status) {
      switch (status) {
        case 1: return 'success'; // confirmed
        case 2: return 'error';   // rejected
        case 0:
        case null:
        case undefined:
        default: return 'warning'; // pending
      }
    },
    getStatusTextColor(status) {
      switch (status) {
        case 1: return 'white';   // confirmed
        case 2: return 'white';   // rejected
        case 0:
        case null:
        case undefined:
        default: return 'black';   // pending
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1: return this.$t('base.confirmed');
        case 2: return this.$t('base.rejected');
        case 0:
        case null:
        case undefined:
        default: return this.$t('base.pending');
      }
    },
    showConfirmDialog(item) {
      this.$root.$emit('confirmDialog', {
        title: this.$t('base.confirm'),
        contents: [
          'Xác nhận tham gia liên viện từ',
          `\b ${item.hospitalCall}?`, '\n',
          'Hành động này không thể hoàn tác.',
        ],
        variant: "confirm",
        data: item,
        onConfirm: this.confirmParticipation,
        textConfirm: this.$t('base.confirm'),
      })
    },
    showRejectDialog(item) {
      this.$root.$emit('confirmDialog', {
        title: this.$t('base.reject'),
        contents: [
          'Từ chối tham gia liên viện từ',
          `\b ${item.hospitalCall}?`, '\n',
          'Hành động này không thể hoàn tác.',
        ],
        variant: "delete",
        data: item,
        onConfirm: this.rejectParticipation,
        textConfirm: this.$t('base.reject'),
      })
    },
    async confirmParticipation(item) {
      let res = await this.put(API2.CONFIRM, {
        path: item.data.confirmId,
        confirmed: "1"
      });
      if (res) {
        this.getItems(this.optionParams);
        this.showToast("success", this.$t("base.notification"), this.$t("base.updateSuccessful"));
      }
    },
    async rejectParticipation(item) {
      let res = await this.put(API2.CONFIRM, {
        path: item.data.confirmId,
        confirmed: "2"
      });
      if (res) {
        this.getItems(this.optionParams);
        this.showToast("success", this.$t("base.notification"), this.$t("base.updateSuccessful"));
      }
    }
  }
};
</script>

<style></style>
